import { Action, UI_LOG_IN_TOGGLE } from "../actions";

export type IsLogInOpenState = boolean;

export const isLogInOpenReducer = (
    state: IsLogInOpenState = false,
    action: Action,
): IsLogInOpenState => {
    switch (action.type) {
        case UI_LOG_IN_TOGGLE:
            return !state;
        default:
            return state;
    }
};
